import axios from "axios";

/** Full origin of the API (no trailing slash), or empty for same-origin `/api` (dev proxy / shared host). */
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    const base = String(config.baseURL || API);
    if (base.includes("ngrok")) {
        config.headers["ngrok-skip-browser-warning"] = "true";
    }
    const token = localStorage.getItem("omx_token");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const onLogin = window.location.pathname === "/login";
            if (!onLogin) {
                localStorage.removeItem("omx_token");
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Unknown error";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    return String(d);
}
